import { BaseRequest } from './BaseRequest';

export class PaymentAccountRequest extends BaseRequest {
    
}